import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import "./styles/ProjectCard.css";

const ProjectCard = ({ project }) => {
  const { id, name, attributes, description, imageUrl, link } = project;
  let hasNoLink = link === "none";

  return (
    <Card className="project-card">
      <CardMedia
        className="project-card-media"
        image={require(`../assets/projectPics/${imageUrl}`)}
        title={name}
        projectid={id}
      />
      <CardContent className="project-card-content">
        {hasNoLink ? (
          <Typography
            className="project-card-name"
          >
            {name}
          </Typography>
        ) : (
          <Typography
            className="project-card-name linked"
            onClick={() => window.open(link, "_blank")}
          >
            {name}
            {" ➚"}
          </Typography>
        )}

        <Typography className="project-card-description">
          {description}
        </Typography>
        <div className="project-attributes-container">
          <div className="project-attributes-container">
            {attributes.languages.map((language, i) => (
              <span className="project-language" key={`lang-${i}`}>
                {language}
                {" | "}
              </span>
            ))}

            {attributes.IDE.map((ide, i) => (
              <span className="project-language" key={`ide-${i}`}>
                {ide}
                {" | "}
              </span>
            ))}

            <span className="project-language">{attributes.Type}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectCard;
